import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-term-condi',
  templateUrl: './term-condi.component.html',
  styleUrls: ['./term-condi.component.css']
})
export class TermCondiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
